import React from 'react';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '@components/PrimaryButton';
import { ModalLayout } from '@layouts';
import { serviceStatusList } from '@constants';
import { useStyles, useStylesButton } from './styles';

const ChangeOrderStatusModal = ({
  open,
  handleClose,
  changeOrderGroupStatus,
  serviceItemsIds,
  currentStatus,
  typeCountUpdate,
}) => {
  const classes = useStyles();
  const classesButton = useStylesButton();
  const { t } = useTranslation('pointOfService');

  const foundServiceStatusIdx = serviceStatusList.indexOf(currentStatus);
  const buttonsList =
    typeCountUpdate === 'group'
      ? serviceStatusList.slice(0, foundServiceStatusIdx)
      : serviceStatusList;

  return (
    <ModalLayout open={open} handleClose={handleClose}>
      <>
        <p className={classes.title}>{t('changeStatusModal')}</p>
        <div>
          {buttonsList.map(buttonText => (
            <PrimaryButton
              key={buttonText}
              text={t(`orderStatusList.${buttonText}`)}
              classesButton={classesButton}
              handleClick={changeOrderGroupStatus(serviceItemsIds, buttonText)}
            />
          ))}
        </div>
      </>
    </ModalLayout>
  );
};

export default ChangeOrderStatusModal;
